import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconProducthunt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconProducthunt"><Path d="M10.5 12.0001L13.3334 12C14.1617 12 14.8334 11.3284 14.8334 10.5C14.8334 9.67155 14.1617 9.00005 13.3334 9.00005H10.5V12.0001Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5229 17.5229 22 12 22C6.47716 22 2 17.5229 2 12C2 6.47716 6.47716 2 12 2C17.5229 2 22 6.47716 22 12ZM8.5 6.99997H13.3334C15.2663 6.99997 16.8334 8.56695 16.8334 10.5C16.8334 12.433 15.2663 14.0001 13.3334 14.0001H10.5V17H8.5V6.99997Z" fill="currentColor"/></CentralIconBase>;
});

export default IconProducthunt;
